import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../constant";
import styles from "./OrderHistory.css";
import Modal from "react-bootstrap/Modal";
import { ProgressBar } from "react-bootstrap";
import { toast } from "react-toastify";
import { IoArrowRedoOutline } from "react-icons/io5";
import Header from "../../components/layout/header";
import { IoStar } from "react-icons/io5";
import Footer from "../../components/layout/footer";

function OrderHistory() {
  const [orders, setOrders] = useState([]);
  const stars = Array.from({ length: 5 });
  const [returnRequestStatuses, setReturnRequestStatuses] = useState({});
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [cancelSerialNo, setCancelSerialNo] = useState(null);
  const [showReturn, setShowReturn] = useState(false);
  const [returnOrder, setReturnOrder] = useState({
    reason: "",
    comment: "",
    accountNumber: "",
    ifscCode: "",
    bankName: "",
    accountHolderName: "",
  });
  const [returnSerialNo, setReturnSerialNo] = useState(null);
  const [show, setShow] = useState(false);
  const [viewOrder, setViewOrder] = useState(null);
  const handleClose = () => setShow(false);
  const handleShow = (order) => {
    setViewOrder(order);
    setShow(true);
  };
  useEffect(() => {
    console.log(viewOrder);
  }, [viewOrder]);
  const handleCancelConfirmClose = () => setShowCancelConfirm(false);
  const handleCancelConfirmShow = (serialNo) => {
    setCancelSerialNo(serialNo);
    setShowCancelConfirm(true);
  };

  const handleReturnClose = () => setShowReturn(false);
  const handleReturnShow = (serialNo) => {
    setReturnSerialNo(serialNo);
    setShowReturn(true);
  };

  const fetchOrders = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await axios.get(
        `${BASE_URL}/orders/summary?userId=${userId}`
      );
      setOrders(response.data);
      response.data.forEach((order) =>
        fetchReturnRequestStatus(order.orders[0].serialNo)
      );
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const fetchReturnRequestStatus = async (serialNo) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/return-request/status?orderId=${serialNo}`
      );
      setReturnRequestStatuses((prevState) => ({
        ...prevState,
        [serialNo]: response.data,
      }));
    } catch (error) {
      console.error("Error fetching return request status:", error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const getProgressPercentage = (status) => {
    switch (status) {
      case "ORDERED":
        return 15;
      case "SHIPPED":
        return 35;
      case "DELIVERED":
        return 65;
      case "CANCELED":
        return 100;
      default:
        return 0;
    }
  };

  const handleCancelOrder = async () => {
    try {
      const response = await axios.put(
        `${BASE_URL}/orders/status/${cancelSerialNo}?newStatus=CANCELED`
      );

      toast.success("Order Cancelled");
      window.location.reload();
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  const handleReturnOrderSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${BASE_URL}/api/return-request/${returnSerialNo}`,
        returnOrder
      );
      toast.success("Return Initiated");
      await fetchOrders();
      handleReturnClose();
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  const handleReturnOrderChange = (e) => {
    const { name, value } = e.target;
    setReturnOrder({ ...returnOrder, [name]: value });
  };

  return (
    <>
      <Header />
      <div
        className={` bg-[#F6F6F6] sm:px-4 md:px-2 lg:px-12 py-5 ${styles.orderhistorypage_container}`}
      >
        <div
          className={`order-history rounded-[20px] bg-[#F6F1FA] pt-3 pb-2 mb-8 md:px-2 lg:px-12 shadow-[0_1px_1px_0px_rgb(167, 187, 0)] ${styles.subcontainer}`}
        >
          <h1 className="text-[24px] font-bold">Order History</h1>

          {orders.length > 0
            ? orders.map((order, index) => (
                <React.Fragment key={index}>
                  <div
                    className={`order-container flex md:gap-4 my-4 ${styles.orderitem_container}`}
                  >
                    <img
                      src={order.orderImage}
                      className={`lg:w-[295px] self-start imageclass`}
                      alt="Order"
                    />
                    <div className="flex flex-col gap-3 sm:flex-row flex-grow">
                      <div className="some-flex-div flex gap-12 flex-col flex-grow">
                        <div className="order-row">
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <h2 className="font-semibold md:text-[20px]">
                                {order.orders[0].productName}
                              </h2>
                              <div style={{ marginLeft: "8px" }}>
                                {order.productCount > 1 ? (
                                  <span>+{order.productCount - 1} more</span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <button
                              onClick={() => {
                                handleShow(order);
                              }}
                              style={{
                                border: "2px solid blue",
                                color: "blue",
                                fontWeight: "600",
                                fontSize: "15px",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                maxHeight: "40px",
                              }}
                              type="button"
                            >
                              View Order
                            </button>
                          </div>
                          <div className="order-product-price">
                            <div className="order-product-rating">
                              <div>
                                {stars.map((_, index) => (
                                  <IoStar
                                    className="star"
                                    size={22}
                                    key={index}
                                  />
                                ))}
                              </div>
                              <p>₹ {order.orders[0].finalOrderAmount}.00</p>
                            </div>
                          </div>
                        </div>

                        <div className="flex text-[#383737] order-details-container">
                          <div className="flex flex-col order-detail-item">
                            <span className="detail-label">Order Placed</span>
                            <span className="detail-value">
                              {new Date(
                                order.orders[0].billDate
                              ).toLocaleDateString("en-GB")}
                            </span>
                          </div>
                          <div className="flex flex-col order-detail-item">
                            <span className="detail-label">Order ID</span>
                            <span className="detail-value">
                              #{order.orders[0].serialNo}
                            </span>
                          </div>
                        </div>
                        <div className="relative">
                          <div className="flex justify-between absolute w-full top-[-1.5rem] left-0">
                            <span className="text-xs font-bold">ORDERED</span>
                            <span className="text-xs font-bold">SHIPPED</span>
                            <span className="text-xs font-bold">DELIVERED</span>
                            <span className="text-xs font-bold">CANCELLED</span>
                          </div>
                          <ProgressBar
                            style={{ height: "10px" }}
                            variant="success"
                            now={getProgressPercentage(
                              order.orders[0].orderStatus
                            )}
                            label={false}
                          />
                        </div>
                      </div>
                      <div className="flex">
                        <div className="flex flex-col">
                          {order.orders[0].orderStatus === "ORDERED" && (
                            <button
                              onClick={() =>
                                handleCancelConfirmShow(
                                  order.orders[0].serialNo
                                )
                              }
                              style={{
                                border: "2px solid #dc3545", // Red color for cancel
                                color: "#dc3545",
                                fontWeight: "600",
                                fontSize: "15px",
                                padding: "5px 10px",
                                borderRadius: "5px",
                              }}
                              type="button"
                            >
                              Cancel Order
                            </button>
                          )}
                          {order.orders[0].orderStatus === "DELIVERED" &&
                            !returnRequestStatuses[
                              order.orders[0].serialNo
                            ] && (
                              <button
                                style={{
                                  border: "2px solid #198754", // Green color for return
                                  color: "#198754",
                                  fontWeight: "600",
                                  fontSize: "15px",
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                }}
                                type="button"
                                onClick={() =>
                                  handleReturnShow(order.orders[0].serialNo)
                                }
                              >
                                Return Order
                              </button>
                            )}
                          {order.orders[0].orderStatus === "DELIVERED" &&
                            returnRequestStatuses[order.orders[0].serialNo] && (
                              <p className="d-flex text-[green] align-items-center font-bold">
                                Return Initiated
                                <IoArrowRedoOutline />
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[99%] h-2 border-t-2 border-[#a29c9c] mx-auto "></div>
                </React.Fragment>
              ))
            : "No Orders"}
        </div>

        {/* Modals for Cancel Confirmation and Return Order */}
        {/* Cancel Confirmation Modal */}
        <Modal show={showCancelConfirm} onHide={handleCancelConfirmClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Cancel Order</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to cancel this order?</Modal.Body>
          <Modal.Footer>
            <button
              // className="btn btn-secondary"
              style={{
                color: "white",
                backgroundColor: "#B2BEB5",
                borderRadius: "7px",
                width: "100px",
              }}
              onClick={handleCancelConfirmClose}
            >
              Close
            </button>
            <button
              // className="btn btn-danger"
              style={{
                color: "white",
                backgroundColor: "#D70040",
                borderRadius: "7px",
                width: "auto",
              }}
              onClick={() => {
                handleCancelOrder();
                handleCancelConfirmClose();
              }}
            >
              Cancel Order
            </button>
          </Modal.Footer>
        </Modal>

        {/* Return Order Modal */}
        <Modal
          show={showReturn}
          onHide={handleReturnClose}
          className="return-order-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Return Order</Modal.Title>
          </Modal.Header>
          <form onSubmit={handleReturnOrderSubmit}>
            <Modal.Body>
              <div className="form-group">
                <label htmlFor="reason">Reason for Return</label>
                <input
                  type="text"
                  id="reason"
                  className="form-control"
                  name="reason"
                  value={returnOrder.reason}
                  onChange={handleReturnOrderChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="comment">Comment (Optional)</label>
                <textarea
                  id="comment"
                  className="form-control"
                  name="comment"
                  value={returnOrder.comment}
                  onChange={handleReturnOrderChange}
                ></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="accountNumber">Bank Account Number</label>
                <input
                  type="text"
                  id="accountNumber"
                  className="form-control"
                  name="accountNumber"
                  value={returnOrder.accountNumber}
                  onChange={handleReturnOrderChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="ifscCode">IFSC Code</label>
                <input
                  type="text"
                  id="ifscCode"
                  className="form-control"
                  name="ifscCode"
                  value={returnOrder.ifscCode}
                  onChange={handleReturnOrderChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="bankName">Bank Name</label>
                <input
                  type="text"
                  id="bankName"
                  className="form-control"
                  name="bankName"
                  value={returnOrder.bankName}
                  onChange={handleReturnOrderChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="accountHolderName">Account Holder Name</label>
                <input
                  type="text"
                  id="accountHolderName"
                  className="form-control"
                  name="accountHolderName"
                  value={returnOrder.accountHolderName}
                  onChange={handleReturnOrderChange}
                  required
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                // className="btn btn-secondary"
                style={{
                  color: "white",
                  backgroundColor: "#D70040",
                  borderRadius: "7px",
                  width: "80px",
                }}
                onClick={handleReturnClose}
              >
                Close
              </button>
              <button
                type="submit"
                // className="btn btn-success"
                style={{
                  color: "white",
                  backgroundColor: "#008000",
                  borderRadius: "7px",
                  width: "auto",
                }}
              >
                Submit Return
              </button>
            </Modal.Footer>
          </form>
        </Modal>
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className={styles.requestACallModal}
        >
          <Modal.Header
            closeButton
            className={styles.requestACallModalHeader}
            style={{ fontWeight: "bold" }}
          >
            Your Order
          </Modal.Header>
          <Modal.Body>
            <ul>
              {viewOrder?.orders.map((product, index) => (
                <li
                  key={index}
                  className="text-[14px] sm:text-[16px]"
                  style={{
                    borderBottom: "1px solid",
                    paddingBlock: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="text-center">
                    Qty. {product.orderQuantity}
                  </span>
                  <span className="text-center">{product.productName}</span>
                  <span className="text-center">Rs. {product.productRate}</span>
                </li>
              ))}
              <li
                className="text-[14px] sm:text-[16px]"
                style={{
                  borderBottom: "1px solid",
                  paddingBlock: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span className="text-center">
                  {viewOrder?.orders[0]?.productObject.productColor}
                </span>
                <span className="text-center">Discount</span>
                <span className="text-center">
                  Rs. {viewOrder?.orders[0]?.discount}
                </span>
              </li>
              <li
                className="text-[14px] sm:text-[16px]"
                style={{
                  borderBottom: "1px solid",
                  paddingBlock: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span className="text-center">
                  {" "}
                  {viewOrder?.orders[0]?.productObject.productSize}
                </span>
                <span className="text-center">Shipping</span>
                <span className="text-center">
                  Rs. {viewOrder?.orders[0]?.shipping}
                </span>
              </li>
            </ul>
          </Modal.Body>
        </Modal>
      </div>
      <Footer />
    </>
  );
}

export default OrderHistory;
